/**
 * "Run stack" glyph for the Manual Summarization nav entry — a stacked-layers
 * mark with a play affordance, matching the 24px stroke style of the other rail
 * icons.
 *
 * @returns The run-stack SVG icon element
 */
export function RunStackIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 2 2 7l10 5 10-5-10-5Z" />
      <path d="m2 17 10 5 10-5" />
      <path d="m2 12 10 5 10-5" />
    </svg>
  );
}
